const subscription = [
    {
        id: '1',
        img: 'assets/images/learning/shopify.png',
        title: 'The Complete Shopify Dropship course',
        type: 'Shopify Development',
        price: '$451.32',
        duration: '6 Months',
        status: 'Active',
        due: true,
        duedate: '2 Days ago',
        action: 'Renew Now',
        bgcolor: 'bg-success-subtle'
    },
    {
        id: '2',
        img: 'assets/images/learning/sketch.png',
        title: 'UI/UX Style guide With Sketch',
        type: 'Graphic Design',
        price: '$239.99',
        duration: '9 Months',
        status: 'Active',
        duedate: '23 March, 2023',
        action: 'Pay Now',
        bgcolor: 'bg-warning-subtle'
    },
    {
        id: '3',
        img: 'assets/images/learning/laravel.png',
        title: 'Master Laravel for Beginners & Intermediate',
        type: 'Laravel Development',
        price: '$159.27',
        duration: '1 Years',
        status: 'Unactive',
        duedate: '15 June, 2022',
        action: 'Pay Now',
        bgcolor: 'bg-danger-subtle'
    },
    {
        id: '4',
        img: 'assets/images/learning/flask.png',
        title: 'REST APIs With Flask',
        type: 'Flask Development',
        price: '$198.16',
        duration: '2 Years',
        status: 'Active',
        duedate: '19 Feb, 2023',
        action: 'Pay Now',
        bgcolor: 'bg-dark-subtle'
    },
    {
        id: '5',
        img: 'assets/images/brands/firefox.png',
        title: 'Conflict Management with Emotional Intelligence',
        type: 'Marketing & Management',
        price: '$324.48',
        duration: '8 Months',
        status: 'Unactive',
        duedate: '24 Jan, 2023',
        action: 'Pay Now',
        bgcolor: 'bg-danger-subtle'
    },
]


const cources = [{
    id: '1',
    img: 'assets/images/learning/react.png',
    postDetail: 'Advanced React And Redux',
    post: 'React Development',
    exLevel: 'Beginner',
    time: '6 Months',
    top: '256',
    lesson: ' 15',
    language: ' English, France',
    price: '$425.36',
    profile: 'assets/images/users/48/avatar-2.jpg',
    name: 'Ayaan Bowen',
    rating: '4.5',
    progresscolor: 'primary',
    progressvalue: 74,
    color: 'info',
    colors: 'success'
},
{
    id: '2',
    img: 'assets/images/learning/laravel.png',
    postDetail: 'Master Laravel For Beginners & Intermediate',
    post: 'Laravel Development',
    exLevel: 'Advance',
    time: '1 Years',
    top: '84',
    lesson: '57',
    language: 'English',
    price: '$264.71',
    profile: 'assets/images/users/48/avatar-6.jpg',
    name: 'Ophelia Steuber',
    rating: '4.8',
    progresscolor: 'warning',
    progressvalue: 53,
    color: 'danger',
    colors: 'info'
},
{
    id: '3',
    img: 'assets/images/learning/core.png',
    postDetail: 'Asp.Net Core 7 True Ultimate Guide',
    post: 'Asp.Net Development',
    exLevel: 'Intermediate',
    time: '8 Years',
    top: '321',
    lesson: '95',
    language: 'English, France',
    price: '$249.99',
    profile: 'assets/images/users/48/avatar-10.jpg',
    name: 'Deondre Huel',
    rating: '4.7',
    progresscolor: 'success',
    progressvalue: 87,
    color: 'primary',
    colors: 'danger'
},
{
    id: '4',
    img: 'assets/images/learning/shopify.png',
    postDetail: 'The Complete Shopify Dropship Course',
    post: 'Shopify Development',
    exLevel: 'Beginner',
    time: '9 Months',
    top: '134',
    lesson: '36',
    language: 'English, France',
    price: '$134.69',
    profile: 'assets/images/users/48/avatar-3.jpg',
    name: 'Nelson Schaden',
    rating: '4.9',
    progresscolor: 'dark',
    progressvalue: 30,
    color: 'success',
    colors: 'success'
}
]

export { subscription, cources }